<template>
  <div class="news-detail">
    <h2>三一金票服务平台上线公告</h2>
    <p class="time">2019-12-06</p>
    <div class="content">
      <img src="../assets/news_1.png" alt style="height: 3.6267rem"/>
      <p class="below-img">尊敬的用户：</p>
      <p>您好！三一金票服务平台于12月6日完成上线，为方便您了解平台及相关产品，您可登录平台官网查看产品介绍等相关内容。</p>
      <p style="text-align: right;">湖南三一金票科技有限公司<br>2019年12月6日</p>
    </div>
    <div class="qrcode">
      <img src="../assets/weixin.png" alt />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less">
.news-detail {
  padding: 80px 30px;
  h2 {
    color: #222;
    font-size: 42px;
  }
  .time {
    font-size: 22px;
    color: #aaa;
    margin-top: 38px;
  }
  .content {
    font-size: 26px;
    color: #808080;
    line-height: 1.6;
    p {
      margin-top: 50px;
      text-indent: 52px;
      &.below-img {
        margin-top: 0;
      }
    }
    h3 {
      font-size: 32px;
      color: #333;
      margin-top: 50px;
    }
    img {
      margin: 44px 0;
    }
  }
  .qrcode {
    margin-top: 70px;
    text-align: center;
    img {
      width: 258px;
      height: 258px;
    }
  }
}
</style>
